export const environment = {
  production: false,
  apiUrl: "https://lina-api.dev.sla-logistics-rmc.devtest.gf.aws.scania.com",
};
